// import React, { useEffect, useState, useRef, useCallback } from 'react';
// import { Sparkles, Package, X, CheckCircle2, AlertTriangle, Trash2 } from 'lucide-react';
// import { Dialog, IconButton, Select, MenuItem, Checkbox, ListItemText, OutlinedInput, Skeleton } from '@mui/material';
// import Apiurl from '../../Helpers/apiUrl';

// const fallbackImage = Apiurl.replace('/api/', '/img/no_image.jpeg');

// export default function AiPreviewModal({
//   isOpen,
//   onClose,
//   onConfirm,
//   payload = [],
//   warnings = [],
//   clientName = null,
//   selections = []
// }) {
//   const [activeBtn, setActiveBtn] = useState('confirm');
//   const [localProducts, setLocalProducts] = useState([]);
//   const [selectedUids, setSelectedUids] = useState(new Set());
  
//   const [isLoading, setIsLoading] = useState(true);
//   const [visibleCount, setVisibleCount] = useState(15);
//   const observerRef = useRef(null);

//   useEffect(() => {
//     if (isOpen) {
//       setIsLoading(true);
//       setVisibleCount(15);
//       const t = setTimeout(() => setIsLoading(false), 600);
//       return () => clearTimeout(t);
//     }
//   }, [isOpen]);

//   const lastElementRef = useCallback((node) => {
//     if (isLoading) return;
//     if (observerRef.current) observerRef.current.disconnect();
//     observerRef.current = new IntersectionObserver((entries) => {
//       if (entries[0].isIntersecting) {
//         setVisibleCount((prev) => prev + 15);
//       }
//     });
//     if (node) observerRef.current.observe(node);
//   }, [isLoading]);

//   // Compute available selections dynamically merging existing and AI-suggested custom names
//   const availableSelections = React.useMemo(() => {
//     const list = [];
//     const usedNames = new Set();

//     // Fill 1-15 with existing selections
//     for (let i = 1; i <= 15; i++) {
//       const existing = selections?.find(s => s.id === i);
//       let displayName = existing ? existing.name : `S${i}`;
//       if (displayName.toLowerCase() === `selection ${i}`) displayName = `S${i}`;
//       list.push({ id: i, name: displayName, isCustom: false });
//       if (existing) usedNames.add(displayName.toLowerCase());
//     }

//     // Merge AI custom selection names into available empty slots
//     (payload || []).forEach(sel => {
//       if (sel.selectionName && !sel.selectionName.toLowerCase().startsWith('selection ')) {
//         if (!usedNames.has(sel.selectionName.toLowerCase())) {
//            // Find first unused S(id) slot
//            const emptySlot = list.find(s => s.name === `S${s.id}`);
//            if (emptySlot) {
//              emptySlot.name = sel.selectionName;
//              emptySlot.isCustom = true;
//              usedNames.add(sel.selectionName.toLowerCase());
//            }
//         }
//       }
//     });
    
//     return list;
//   }, [selections, payload]);

//   useEffect(() => {
//     const products = [];
//     (payload || []).forEach((sel, sIdx) => {
//       let defaultSelectionId = sel.selectionIndex || sIdx + 1;
      
//       // If AI specified a custom name, try to map it to the slot we assigned in availableSelections
//       if (sel.selectionName && !sel.selectionName.toLowerCase().startsWith('selection ')) {
//          const matchedSlot = availableSelections.find(s => s.name.toLowerCase() === sel.selectionName.toLowerCase());
//          if (matchedSlot) defaultSelectionId = matchedSlot.id;
//       }
      
//       sel.products.forEach(p => {
//         products.push({
//           ...p,
//           _uid: p._uid || Math.random().toString(36).substr(2, 9),
//           targetSelections: [defaultSelectionId]
//         });
//       });
//     });
//     setLocalProducts(products);

//     const uids = new Set(products.map(p => p._uid));
//     setSelectedUids(uids);
//   }, [payload, availableSelections]);

//   useEffect(() => {
//     if (isOpen) {
//       setActiveBtn('confirm');
//     }
//   }, [isOpen]);

//   useEffect(() => {
//     if (!isOpen) return;
//     const handleKeyDown = (event) => {
//       if (['INPUT', 'SELECT', 'TEXTAREA'].includes(document.activeElement.tagName) || document.activeElement.getAttribute('role') === 'listbox') return;
//       if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
//         event.preventDefault();
//         setActiveBtn(prev => prev === 'confirm' ? 'cancel' : 'confirm');
//       } else if (event.key === 'Enter') {
//         event.preventDefault();
//         if (activeBtn === 'confirm') handleConfirm();
//         else onClose();
//       }
//     };
//     window.addEventListener('keydown', handleKeyDown);
//     return () => window.removeEventListener('keydown', handleKeyDown);
//   }, [isOpen, onConfirm, onClose, activeBtn]);

//   if (!isOpen) return null;

//   const handleSelectionChange = (uid, event) => {
//     const value = event.target.value;
//     setLocalProducts(prev => prev.map(p => p._uid === uid ? { ...p, targetSelections: typeof value === 'string' ? value.split(',') : value } : p));
//   };

//   const handleDelete = (uid) => {
//     setLocalProducts(prev => prev.filter(p => p._uid !== uid));
//   };

//   const handleQuantityChange = (uid, val) => {
//     setLocalProducts(prev => prev.map(p => p._uid === uid ? { ...p, quantity: val } : p));
//   };

//   const handleDiscountChange = (uid, val) => {
//     setLocalProducts(prev => prev.map(p => p._uid === uid ? { ...p, discountPercent: val, discountPrice: 0 } : p));
//   };

//   const handleConfirm = () => {
//     const selectionMap = {};
//     localProducts.filter(p => selectedUids.has(p._uid)).forEach(p => {
//        const qty = p.quantity === '' || p.quantity === undefined ? 1 : Number(p.quantity);
//        const disc = p.discountPercent === '' || p.discountPercent === undefined ? 0 : Number(p.discountPercent);
//        const productToCopy = { ...p, quantity: qty, discountPercent: disc };
       
//        p.targetSelections.forEach(selId => {
//           if (!selectionMap[selId]) selectionMap[selId] = [];
//           selectionMap[selId].push(productToCopy);
//        });
//     });

//     const filteredPayload = Object.keys(selectionMap).map(selId => {
//        const id = Number(selId);
//        const selName = availableSelections.find(s => s.id === id)?.name || `Selection ${id}`;
//        return {
//           selectionIndex: id,
//           selectionName: selName,
//           products: selectionMap[selId]
//        };
//     });
    
//     onConfirm(filteredPayload);
//   };

//   const toggleSelectAll = () => {
//     if (selectedUids.size === localProducts.length) {
//       setSelectedUids(new Set());
//     } else {
//       setSelectedUids(new Set(localProducts.map(p => p._uid)));
//     }
//   };

//   const toggleSelection = (uid) => {
//     setSelectedUids(prev => {
//       const next = new Set(prev);
//       if (next.has(uid)) next.delete(uid);
//       else next.add(uid);
//       return next;
//     });
//   };

//   const getRenderValue = (selected) => {
//     if (selected.length === 0) return <em>Select...</em>;
//     const firstSelId = selected[0];
//     const firstName = availableSelections.find(s => s.id === firstSelId)?.name || `S${firstSelId}`;
//     if (selected.length === 1) return firstName;
//     return `${firstName} (+${selected.length - 1})`;
//   };

//   return (
//     <Dialog
//       open={isOpen}
//       onClose={onClose}
//       maxWidth="md"
//       fullWidth
//       slotProps={{ backdrop: { style: { backgroundColor: 'rgba(15, 23, 42, 0.55)', backdropFilter: 'blur(4px)' } } }}
//       PaperProps={{ sx: { borderRadius: '16px', fontFamily: "'DM Sans', sans-serif", overflow: 'visible' } }}
//     >
//       <div className="flex items-start gap-3 px-5 pt-5 pb-4 bg-orange-50 border-b border-orange-200">
//         <div className="flex-shrink-0 w-10 h-10 rounded-xl bg-orange-600 shadow-md shadow-orange-600/30 flex items-center justify-center">
//           <Sparkles size={20} className="text-white" />
//         </div>
//         <div className="flex-1 min-w-0">
//           <h2 className="text-[16px] font-bold text-orange-900 leading-tight flex items-center gap-2">
//             AI Extraction Preview
//             {clientName && (
//               <span className="px-2 py-0.5 text-[12px] bg-orange-200 text-orange-900 rounded-md font-semibold truncate max-w-[200px]">
//                 Client: {clientName}
//               </span>
//             )}
//           </h2>
//           <p className="text-[13px] text-orange-700 mt-0.5 leading-snug">
//             Review the {localProducts.length} items extracted by the AI before adding them to your quotation.
//           </p>
//         </div>
//         <IconButton onClick={onClose} size="small" className="text-orange-500 hover:bg-orange-100">
//           <X size={18} />
//         </IconButton>
//       </div>

//       <div className="flex-1 overflow-y-visible px-5 py-4 bg-slate-50 min-h-[300px] max-h-[60vh]" style={{ overflowY: 'auto' }}>
//         {warnings.length > 0 && (
//           <div className="mb-4 bg-amber-50 border border-amber-200 rounded-xl p-3 flex items-start gap-3">
//             <AlertTriangle size={18} className="text-amber-600 mt-0.5 flex-shrink-0" />
//             <div>
//               <h4 className="text-[13px] font-bold text-amber-900">Some items were not found</h4>
//               <p className="text-[12px] text-amber-700 mt-0.5">
//                 The AI could not find matching products in the catalog for: <span className="font-semibold">{warnings.join(', ')}</span>
//               </p>
//             </div>
//           </div>
//         )}

//         <div className="space-y-3">
//           {localProducts.length > 0 && (
//             <div className="flex justify-end px-2 mb-1">
//               <button 
//                 onClick={toggleSelectAll} 
//                 className="text-[13px] text-indigo-600 font-semibold hover:text-indigo-800 transition-colors"
//               >
//                 {selectedUids.size === localProducts.length ? 'Unselect All' : 'Select All'}
//               </button>
//             </div>
//           )}

//           {isLoading ? (
//             Array.from({ length: 5 }).map((_, i) => (
//               <div key={i} className="flex flex-col sm:flex-row sm:items-center gap-3 px-4 py-3 rounded-xl bg-white border border-slate-200 shadow-sm">
//                 <Skeleton variant="rounded" width={40} height={40} />
//                 <div className="flex-1">
//                   <Skeleton variant="text" width="40%" height={20} />
//                   <Skeleton variant="text" width="80%" height={16} />
//                 </div>
//                 <Skeleton variant="rounded" width={100} height={30} />
//                 <Skeleton variant="rounded" width={80} height={30} />
//               </div>
//             ))
//           ) : localProducts.length === 0 ? (
//              <div className="text-center py-10">
//                <p className="text-slate-500 text-sm">No valid products were extracted.</p>
//              </div>
//           ) : (
//             <>
//               {localProducts.slice(0, visibleCount).map((p, index) => {
//                 const stockRaw = p.stockAvailable || p.stock || 0;
//                 const stockVal = Number(stockRaw);
//                 const isZeroStock = (stockVal <= 0 && !isNaN(stockVal)) || String(stockRaw).trim() === '0';
                
//                 const isLast = index === Math.min(localProducts.length, visibleCount) - 1;
                
//                 return (
//                   <div
//                     ref={isLast ? lastElementRef : null}
//                     key={p._uid}
//                 className="flex flex-col sm:flex-row sm:items-center gap-3 px-4 py-3 rounded-xl bg-white border border-slate-200 shadow-sm"
//               >
//                 <div className="flex items-center gap-3 flex-1 min-w-0">
//                   <div className="flex items-center justify-center pl-1 pr-2">
//                     <input 
//                       type="checkbox" 
//                       className="w-4 h-4 text-orange-600 bg-slate-100 border-slate-300 rounded focus:ring-orange-500 cursor-pointer"
//                       checked={selectedUids.has(p._uid)}
//                       onChange={() => toggleSelection(p._uid)}
//                     />
//                   </div>
//                   <div className="relative group/img cursor-pointer">
//                     <img
//                       src={p.image || fallbackImage}
//                       alt={p.productCode}
//                       onError={(e) => { e.target.onerror = null; p.image = fallbackImage; e.target.src = fallbackImage; }}
//                       className="w-10 h-10 rounded-lg object-cover flex-shrink-0 border border-slate-100"
//                     />
//                     <div className="hidden group-hover/img:block absolute top-0 left-12 z-50 p-1 bg-white rounded-xl shadow-xl border border-slate-200 w-48 h-48">
//                         <img src={p.image || fallbackImage} onError={(e) => { e.target.onerror = null; p.image = fallbackImage; e.target.src = fallbackImage; }} className="w-full h-full object-contain rounded-lg" />
//                     </div>
//                   </div>

//                   <div className="flex-1 min-w-0">
//                     <div className="flex items-center gap-2 flex-wrap mb-0.5">
//                       <span className="text-[13px] font-extrabold text-slate-800 tracking-wide font-mono">
//                         {p.productCode}
//                       </span>
//                       {p.brand && (
//                         <span className="text-[10px] font-bold text-slate-500 bg-slate-100 px-1.5 py-0.5 rounded-md uppercase tracking-wider">
//                           {p.brand}
//                         </span>
//                       )}
//                       {p.mrp !== undefined && p.mrp !== null && (
//                         <span className="text-[10px] font-bold text-emerald-600 bg-emerald-50 border border-emerald-200 px-1.5 py-0.5 rounded-md tracking-wide">
//                           MRP: ₹{Number(p.mrp).toLocaleString('en-IN')}
//                         </span>
//                       )}
//                     </div>
//                     <p className="text-[12px] text-slate-500 truncate leading-tight mb-1">
//                       {p.description || 'No description available'}
//                     </p>
//                     <div className="flex flex-wrap gap-1.5 mt-1">
//                       {p.collection && <span className="text-[9px] font-bold px-1.5 py-0.5 rounded bg-blue-50 text-blue-700 border border-blue-100">{p.collection}</span>}
//                       {p.productType && <span className="text-[9px] font-bold px-1.5 py-0.5 rounded bg-purple-50 text-purple-700 border border-purple-100">{p.productType}</span>}
//                       {p.category && <span className="text-[9px] font-bold px-1.5 py-0.5 rounded bg-pink-50 text-pink-700 border border-pink-100">{p.category}</span>}
//                       {p.priceSegment && <span className="text-[9px] font-bold px-1.5 py-0.5 rounded bg-teal-50 text-teal-700 border border-teal-100">{p.priceSegment}</span>}
//                       {p.finish && <span className="text-[9px] font-bold px-1.5 py-0.5 rounded bg-yellow-50 text-yellow-800 border border-yellow-200">{p.finish}</span>}
//                     </div>
//                   </div>
//                 </div>

//                 <div className="flex flex-wrap items-center sm:justify-end gap-x-4 gap-y-2 mt-2 sm:mt-0 pt-2 sm:pt-0 border-t sm:border-t-0 border-slate-100">
//                   <div className="flex flex-col items-start sm:items-end w-full sm:w-auto">
//                     <span className="text-[10px] text-slate-400 font-bold uppercase tracking-wider mb-0.5">Destination</span>
//                     <Select
//                       multiple
//                       displayEmpty
//                       value={p.targetSelections || []}
//                       onChange={(e) => handleSelectionChange(p._uid, e)}
//                       input={<OutlinedInput sx={{ height: 26, fontSize: '11px', borderRadius: '6px', fontWeight: 600, minWidth: '120px', '.MuiOutlinedInput-notchedOutline': { borderColor: '#e0e7ff' } }} />}
//                       renderValue={getRenderValue}
//                       MenuProps={{ PaperProps: { style: { maxHeight: 224, width: 200 } } }}
//                       sx={{
//                         '.MuiSelect-select': { paddingY: 0, paddingX: 1, backgroundColor: '#eef2ff', color: '#4338ca' },
//                         '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: '#c7d2fe !important' },
//                         '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: '#6366f1 !important' }
//                       }}
//                     >
//                       {availableSelections.map((sel) => (
//                         <MenuItem key={sel.id} value={sel.id} sx={{ fontSize: '12px', paddingY: 0.5 }}>
//                           <Checkbox checked={(p.targetSelections || []).indexOf(sel.id) > -1} size="small" />
//                           <ListItemText primary={sel.name} primaryTypographyProps={{ fontSize: '12px' }} />
//                         </MenuItem>
//                       ))}
//                     </Select>
//                   </div>
                  
//                   <div className="flex flex-col items-start sm:items-end w-full sm:w-auto mt-1 sm:mt-0">
//                     <div className="flex gap-2">
//                        <div className="flex items-center bg-white rounded-md border border-slate-200 overflow-hidden">
//                            <input 
//                              type="text"
//                              maxLength="2"
//                              className="w-12 h-6 text-[12px] font-bold text-slate-700 bg-transparent border-none outline-none text-center"
//                              value={p.quantity !== undefined ? p.quantity : 1}
//                              onChange={(e) => {
//                                if (/^\d{0,2}$/.test(e.target.value)) handleQuantityChange(p._uid, e.target.value);
//                              }}
//                            />
//                        </div>
//                        <div className="flex items-center bg-white rounded-md border border-slate-200 overflow-hidden">
//                            <input 
//                              type="text"
//                              maxLength="5"
//                              className="w-12 h-6 text-[12px] font-bold text-emerald-700 bg-transparent border-none outline-none text-center"
//                              value={p.discountPercent !== undefined ? p.discountPercent : 0}
//                              onChange={(e) => {
//                                if (/^\d{0,2}(\.\d{0,2})?$/.test(e.target.value)) handleDiscountChange(p._uid, e.target.value);
//                              }}
//                            />
//                        </div>
//                     </div>
//                   </div>

//                   <div className="flex flex-col items-start sm:items-end w-full sm:w-auto">
//                     <span className="text-[10px] text-slate-400 font-bold uppercase tracking-wider mb-0.5">Stock</span>
//                     <span
//                       className="text-[11px] font-bold px-2 py-0.5 rounded-md"
//                       style={isZeroStock ? { background: '#fee2e2', color: '#b91c1c', border: '1px solid #fecaca' } : { background: '#dcfce7', color: '#166534', border: '1px solid #bbf7d0' }}
//                     >
//                       {stockRaw} {p.stockIndicator ? `(${p.stockIndicator})` : '(MTS)'}
//                     </span>
//                   </div>
                  
//                   <div className="flex flex-col items-start sm:items-end w-full sm:w-auto ml-2 border-l border-slate-100 pl-4">
//                     <IconButton 
//                       size="small" 
//                       onClick={() => handleDelete(p._uid)}
//                       sx={{ color: '#ef4444', backgroundColor: '#fef2f2', '&:hover': { backgroundColor: '#fee2e2' } }}
//                     >
//                       <Trash2 size={16} />
//                     </IconButton>
//                   </div>
//                 </div>
//               </div>
//             );
//           })}
//           {/* End of mapping */}
//               </>
//             )}
//         </div>
//       </div>

//       <div className="flex items-center justify-end gap-2 px-5 py-4 border-t border-slate-100 bg-white">
//         <button
//           onClick={onClose}
//           className={`px-4 py-2.5 text-[13px] font-semibold transition-all rounded-xl ${
//             activeBtn === 'cancel'
//               ? 'bg-slate-200 text-slate-800 ring-2 ring-slate-400 ring-offset-2'
//               : 'bg-slate-100 text-slate-600 hover:bg-slate-200'
//           }`}
//         >
//           Cancel
//         </button>
//         <button
//           onClick={handleConfirm}
//           disabled={localProducts.length === 0 || selectedUids.size === 0}
//           className={`relative z-50 flex items-center justify-center gap-1.5 px-5 py-2.5 text-[13px] font-bold text-white rounded-xl cursor-pointer transition-all hover:scale-[1.02] active:scale-[0.98] disabled:opacity-50 disabled:cursor-not-allowed ${
//             activeBtn === 'confirm' ? 'ring-2 ring-orange-500 ring-offset-2' : ''
//           }`}
//           style={{
//             background: 'linear-gradient(135deg, #ea580c, #c2410c)',
//             boxShadow: '0 4px 14px rgba(234, 88, 12, 0.4)',
//           }}
//         >
//           <CheckCircle2 size={16} strokeWidth={2.5} />
//           <span>Confirm & Add to Quotation</span>
//         </button>
//       </div>
//     </Dialog>
//   );
// }


import React, { useEffect, useState, useRef, useCallback } from 'react';
import { Sparkles, Package, X, CheckCircle2, AlertTriangle, Trash2 } from 'lucide-react';
import { Dialog, IconButton, Select, MenuItem, Checkbox, ListItemText, OutlinedInput, Skeleton } from '@mui/material';
import Apiurl from '../../Helpers/apiUrl';

const fallbackImage = Apiurl.replace('/api/', '/img/no_image.jpeg');

export default function AiPreviewModal({
  isOpen,
  onClose,
  onConfirm,
  payload = [],
  warnings = [],
  clientName = null,
  selections = []
}) {
  const [activeBtn, setActiveBtn] = useState('confirm');
  const [localProducts, setLocalProducts] = useState([]);
  const [selectedUids, setSelectedUids] = useState(new Set());
  
  const [isLoading, setIsLoading] = useState(true);
  const [visibleCount, setVisibleCount] = useState(15);
  const observerRef = useRef(null);

  useEffect(() => {
    if (isOpen) {
      setIsLoading(true);
      setVisibleCount(15);
      const t = setTimeout(() => setIsLoading(false), 600);
      return () => clearTimeout(t);
    }
  }, [isOpen]);

  const lastElementRef = useCallback((node) => {
    if (isLoading) return;
    if (observerRef.current) observerRef.current.disconnect();
    observerRef.current = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting) {
        setVisibleCount((prev) => prev + 15);
      }
    });
    if (node) observerRef.current.observe(node);
  }, [isLoading]);

  // Compute available selections dynamically using serialized dependencies to prevent reference churn
  const payloadKey = JSON.stringify(payload?.map(p => p.selectionName));
  const selectionsKey = JSON.stringify(selections?.map(s => s.name));

  const availableSelections = React.useMemo(() => {
    const list = [];
    const usedNames = new Set();

    // Fill 1-15 with existing selections
    for (let i = 1; i <= 15; i++) {
      const existing = selections?.find(s => s.id === i);
      let displayName = existing ? existing.name : `S${i}`;
      if (displayName.toLowerCase() === `selection ${i}`) displayName = `S${i}`;
      list.push({ id: i, name: displayName, isCustom: false });
      if (existing) usedNames.add(displayName.toLowerCase());
    }

    // Merge AI custom selection names into available empty slots
    (payload || []).forEach(sel => {
      if (sel.selectionName && !sel.selectionName.toLowerCase().startsWith('selection ')) {
        if (!usedNames.has(sel.selectionName.toLowerCase())) {
           const emptySlot = list.find(s => s.name === `S${s.id}`);
           if (emptySlot) {
             emptySlot.name = sel.selectionName;
             emptySlot.isCustom = true;
             usedNames.add(sel.selectionName.toLowerCase());
           }
        }
      }
    });
    
    return list;
  }, [selectionsKey, payloadKey]);

  useEffect(() => {
    const products = [];
    (payload || []).forEach((sel, sIdx) => {
      let defaultSelectionId = sel.selectionIndex || sIdx + 1;
      
      if (sel.selectionName && !sel.selectionName.toLowerCase().startsWith('selection ')) {
         const matchedSlot = availableSelections.find(s => s.name.toLowerCase() === sel.selectionName.toLowerCase());
         if (matchedSlot) defaultSelectionId = matchedSlot.id;
      }
      
      sel.products.forEach(p => {
        products.push({
          ...p,
          _uid: p._uid || Math.random().toString(36).substr(2, 9),
          targetSelections: [defaultSelectionId]
        });
      });
    });
    setLocalProducts(products);

    const uids = new Set(products.map(p => p._uid));
    setSelectedUids(uids);
  }, [payloadKey, availableSelections]);

  useEffect(() => {
    if (isOpen) {
      setActiveBtn('confirm');
    }
  }, [isOpen]);

  useEffect(() => {
    if (!isOpen) return;
    const handleKeyDown = (event) => {
      if (['INPUT', 'SELECT', 'TEXTAREA'].includes(document.activeElement.tagName) || document.activeElement.getAttribute('role') === 'listbox') return;
      if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
        event.preventDefault();
        setActiveBtn(prev => prev === 'confirm' ? 'cancel' : 'confirm');
      } else if (event.key === 'Enter') {
        event.preventDefault();
        if (activeBtn === 'confirm') handleConfirm();
        else onClose();
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [isOpen, onConfirm, onClose, activeBtn]);

  if (!isOpen) return null;

  const handleSelectionChange = (uid, event) => {
    const value = event.target.value;
    setLocalProducts(prev => prev.map(p => p._uid === uid ? { ...p, targetSelections: typeof value === 'string' ? value.split(',') : value } : p));
  };

  const handleDelete = (uid) => {
    setLocalProducts(prev => prev.filter(p => p._uid !== uid));
  };

  const handleQuantityChange = (uid, val) => {
    setLocalProducts(prev => prev.map(p => p._uid === uid ? { ...p, quantity: val } : p));
  };

  const handleDiscountChange = (uid, val) => {
    setLocalProducts(prev => prev.map(p => p._uid === uid ? { ...p, discountPercent: val, discountPrice: 0 } : p));
  };

  const handleConfirm = () => {
    const selectionMap = {};
    localProducts.filter(p => selectedUids.has(p._uid)).forEach(p => {
       const qty = p.quantity === '' || p.quantity === undefined ? 1 : Number(p.quantity);
       const disc = p.discountPercent === '' || p.discountPercent === undefined ? 0 : Number(p.discountPercent);
       const productToCopy = { ...p, quantity: qty, discountPercent: disc };
       
       p.targetSelections.forEach(selId => {
          if (!selectionMap[selId]) selectionMap[selId] = [];
          selectionMap[selId].push(productToCopy);
       });
    });

    const filteredPayload = Object.keys(selectionMap).map(selId => {
       const id = Number(selId);
       const selName = availableSelections.find(s => s.id === id)?.name || `Selection ${id}`;
       return {
          selectionIndex: id,
          selectionName: selName,
          products: selectionMap[selId]
       };
    });
    
    onConfirm(filteredPayload);
  };

  const toggleSelectAll = () => {
    if (selectedUids.size === localProducts.length) {
      setSelectedUids(new Set());
    } else {
      setSelectedUids(new Set(localProducts.map(p => p._uid)));
    }
  };

  const toggleSelection = (uid) => {
    setSelectedUids(prev => {
      const next = new Set(prev);
      if (next.has(uid)) next.delete(uid);
      else next.add(uid);
      return next;
    });
  };

  const getRenderValue = (selected) => {
    if (selected.length === 0) return <em>Select...</em>;
    const firstSelId = selected[0];
    const firstName = availableSelections.find(s => s.id === firstSelId)?.name || `S${firstSelId}`;
    if (selected.length === 1) return firstName;
    return `${firstName} (+${selected.length - 1})`;
  };

  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      slotProps={{ backdrop: { style: { backgroundColor: 'rgba(15, 23, 42, 0.55)', backdropFilter: 'blur(4px)' } } }}
      PaperProps={{ sx: { borderRadius: '16px', fontFamily: "'DM Sans', sans-serif", overflow: 'visible' } }}
    >
      <div className="flex items-start gap-3 px-5 pt-5 pb-4 bg-orange-50 border-b border-orange-200">
        <div className="flex-shrink-0 w-10 h-10 rounded-xl bg-orange-600 shadow-md shadow-orange-600/30 flex items-center justify-center">
          <Sparkles size={20} className="text-white" />
        </div>
        <div className="flex-1 min-w-0">
          <h2 className="text-[16px] font-bold text-orange-900 leading-tight flex items-center gap-2">
            AI Extraction Preview
            {clientName && (
              <span className="px-2 py-0.5 text-[12px] bg-orange-200 text-orange-900 rounded-md font-semibold truncate max-w-[200px]">
                Client: {clientName}
              </span>
            )}
          </h2>
          <p className="text-[13px] text-orange-700 mt-0.5 leading-snug">
            Review the {localProducts.length} items extracted by the AI before adding them to your quotation.
          </p>
        </div>
        <IconButton onClick={onClose} size="small" className="text-orange-500 hover:bg-orange-100">
          <X size={18} />
        </IconButton>
      </div>

      <div className="flex-1 overflow-y-visible px-5 py-4 bg-slate-50 min-h-[300px] max-h-[60vh]" style={{ overflowY: 'auto' }}>
        {warnings.length > 0 && (
          <div className="mb-4 bg-amber-50 border border-amber-200 rounded-xl p-3 flex items-start gap-3">
            <AlertTriangle size={18} className="text-amber-600 mt-0.5 flex-shrink-0" />
            <div>
              <h4 className="text-[13px] font-bold text-amber-900">Some items were not found</h4>
              <p className="text-[12px] text-amber-700 mt-0.5">
                The AI could not find matching products in the catalog for: <span className="font-semibold">{warnings.join(', ')}</span>
              </p>
            </div>
          </div>
        )}

        <div className="space-y-3">
          {localProducts.length > 0 && (
            <div className="flex justify-end px-2 mb-1">
              <button 
                onClick={toggleSelectAll} 
                className="text-[13px] text-indigo-600 font-semibold hover:text-indigo-800 transition-colors"
              >
                {selectedUids.size === localProducts.length ? 'Unselect All' : 'Select All'}
              </button>
            </div>
          )}

          {isLoading ? (
            Array.from({ length: 5 }).map((_, i) => (
              <div key={i} className="flex flex-col sm:flex-row sm:items-center gap-3 px-4 py-3 rounded-xl bg-white border border-slate-200 shadow-sm">
                <Skeleton variant="rounded" width={40} height={40} />
                <div className="flex-1">
                  <Skeleton variant="text" width="40%" height={20} />
                  <Skeleton variant="text" width="80%" height={16} />
                </div>
                <Skeleton variant="rounded" width={100} height={30} />
                <Skeleton variant="rounded" width={80} height={30} />
              </div>
            ))
          ) : localProducts.length === 0 ? (
             <div className="text-center py-10">
               <p className="text-slate-500 text-sm">No valid products were extracted.</p>
             </div>
          ) : (
            <>
              {localProducts.slice(0, visibleCount).map((p, index) => {
                const stockRaw = p.stockAvailable || p.stock || 0;
                const stockVal = Number(stockRaw);
                const isZeroStock = (stockVal <= 0 && !isNaN(stockVal)) || String(stockRaw).trim() === '0';
                
                const isLast = index === Math.min(localProducts.length, visibleCount) - 1;
                
                return (
                  <div
                    ref={isLast ? lastElementRef : null}
                    key={p._uid}
                className="flex flex-col sm:flex-row sm:items-center gap-3 px-4 py-3 rounded-xl bg-white border border-slate-200 shadow-sm"
              >
                <div className="flex items-center gap-3 flex-1 min-w-0">
                  <div className="flex items-center justify-center pl-1 pr-2">
                    <input 
                      type="checkbox" 
                      className="w-4 h-4 text-orange-600 bg-slate-100 border-slate-300 rounded focus:ring-orange-500 cursor-pointer"
                      checked={selectedUids.has(p._uid)}
                      onChange={() => toggleSelection(p._uid)}
                    />
                  </div>
                  <div className="relative group/img cursor-pointer">
                    <img
                      src={p.image || fallbackImage}
                      alt={p.productCode}
                      onError={(e) => { e.target.onerror = null; p.image = fallbackImage; e.target.src = fallbackImage; }}
                      className="w-10 h-10 rounded-lg object-cover flex-shrink-0 border border-slate-100"
                    />
                    <div className="hidden group-hover/img:block absolute top-0 left-12 z-50 p-1 bg-white rounded-xl shadow-xl border border-slate-200 w-48 h-48">
                        <img src={p.image || fallbackImage} onError={(e) => { e.target.onerror = null; p.image = fallbackImage; e.target.src = fallbackImage; }} className="w-full h-full object-contain rounded-lg" />
                    </div>
                  </div>

                  <div className="flex-1 min-w-0">
                    <div className="flex items-center gap-2 flex-wrap mb-0.5">
                      <span className="text-[13px] font-extrabold text-slate-800 tracking-wide font-mono">
                        {p.productCode}
                      </span>
                      {p.brand && (
                        <span className="text-[10px] font-bold text-slate-500 bg-slate-100 px-1.5 py-0.5 rounded-md uppercase tracking-wider">
                          {p.brand}
                        </span>
                      )}
                      {p.mrp !== undefined && p.mrp !== null && (
                        <span className="text-[10px] font-bold text-emerald-600 bg-emerald-50 border border-emerald-200 px-1.5 py-0.5 rounded-md tracking-wide">
                          MRP: ₹{Number(p.mrp).toLocaleString('en-IN')}
                        </span>
                      )}
                    </div>
                    <p className="text-[12px] text-slate-500 truncate leading-tight mb-1">
                      {p.description || 'No description available'}
                    </p>
                    <div className="flex flex-wrap gap-1.5 mt-1">
                      {p.collection && <span className="text-[9px] font-bold px-1.5 py-0.5 rounded bg-blue-50 text-blue-700 border border-blue-100">{p.collection}</span>}
                      {p.productType && <span className="text-[9px] font-bold px-1.5 py-0.5 rounded bg-purple-50 text-purple-700 border border-purple-100">{p.productType}</span>}
                      {p.category && <span className="text-[9px] font-bold px-1.5 py-0.5 rounded bg-pink-50 text-pink-700 border border-pink-100">{p.category}</span>}
                      {p.priceSegment && <span className="text-[9px] font-bold px-1.5 py-0.5 rounded bg-teal-50 text-teal-700 border border-teal-100">{p.priceSegment}</span>}
                      {p.finish && <span className="text-[9px] font-bold px-1.5 py-0.5 rounded bg-yellow-50 text-yellow-800 border border-yellow-200">{p.finish}</span>}
                    </div>
                  </div>
                </div>

                <div className="flex flex-wrap items-center sm:justify-end gap-x-4 gap-y-2 mt-2 sm:mt-0 pt-2 sm:pt-0 border-t sm:border-t-0 border-slate-100">
                  <div className="flex flex-col items-start sm:items-end w-full sm:w-auto">
                    <span className="text-[10px] text-slate-400 font-bold uppercase tracking-wider mb-0.5">Destination</span>
                    <Select
                      multiple
                      displayEmpty
                      value={p.targetSelections || []}
                      onChange={(e) => handleSelectionChange(p._uid, e)}
                      input={<OutlinedInput sx={{ height: 26, fontSize: '11px', borderRadius: '6px', fontWeight: 600, minWidth: '120px', '.MuiOutlinedInput-notchedOutline': { borderColor: '#e0e7ff' } }} />}
                      renderValue={getRenderValue}
                      MenuProps={{ PaperProps: { style: { maxHeight: 224, width: 200 } } }}
                      sx={{
                        '.MuiSelect-select': { paddingY: 0, paddingX: 1, backgroundColor: '#eef2ff', color: '#4338ca' },
                        '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: '#c7d2fe !important' },
                        '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: '#6366f1 !important' }
                      }}
                    >
                      {availableSelections.map((sel) => (
                        <MenuItem key={sel.id} value={sel.id} sx={{ fontSize: '12px', paddingY: 0.5 }}>
                          <Checkbox checked={(p.targetSelections || []).indexOf(sel.id) > -1} size="small" />
                          <ListItemText primary={sel.name} primaryTypographyProps={{ fontSize: '12px' }} />
                        </MenuItem>
                      ))}
                    </Select>
                  </div>
                  
                  <div className="flex flex-col items-start sm:items-end w-full sm:w-auto mt-1 sm:mt-0">
                    <div className="flex gap-2">
                       <div className="flex items-center bg-white rounded-md border border-slate-200 overflow-hidden">
                           <input 
                             type="text"
                             maxLength="2"
                             className="w-12 h-6 text-[12px] font-bold text-slate-700 bg-transparent border-none outline-none text-center"
                             value={p.quantity !== undefined ? p.quantity : 1}
                             onChange={(e) => {
                               if (/^\d{0,2}$/.test(e.target.value)) handleQuantityChange(p._uid, e.target.value);
                             }}
                           />
                       </div>
                       <div className="flex items-center bg-white rounded-md border border-slate-200 overflow-hidden">
                           <input 
                             type="text"
                             maxLength="5"
                             className="w-12 h-6 text-[12px] font-bold text-emerald-700 bg-transparent border-none outline-none text-center"
                             value={p.discountPercent !== undefined ? p.discountPercent : 0}
                             onChange={(e) => {
                               if (/^\d{0,2}(\.\d{0,2})?$/.test(e.target.value)) handleDiscountChange(p._uid, e.target.value);
                             }}
                           />
                       </div>
                    </div>
                  </div>

                  <div className="flex flex-col items-start sm:items-end w-full sm:w-auto">
                    <span className="text-[10px] text-slate-400 font-bold uppercase tracking-wider mb-0.5">Stock</span>
                    <span
                      className="text-[11px] font-bold px-2 py-0.5 rounded-md"
                      style={isZeroStock ? { background: '#fee2e2', color: '#b91c1c', border: '1px solid #fecaca' } : { background: '#dcfce7', color: '#166534', border: '1px solid #bbf7d0' }}
                    >
                      {stockRaw} {p.stockIndicator ? `(${p.stockIndicator})` : '(MTS)'}
                    </span>
                  </div>
                  
                  <div className="flex flex-col items-start sm:items-end w-full sm:w-auto ml-2 border-l border-slate-100 pl-4">
                    <IconButton 
                      size="small" 
                      onClick={() => handleDelete(p._uid)}
                      sx={{ color: '#ef4444', backgroundColor: '#fef2f2', '&:hover': { backgroundColor: '#fee2e2' } }}
                    >
                      <Trash2 size={16} />
                    </IconButton>
                  </div>
                </div>
              </div>
            );
          })}
              </>
            )}
        </div>
      </div>

      <div className="flex items-center justify-end gap-2 px-5 py-4 border-t border-slate-100 bg-white">
        <button
          onClick={onClose}
          className={`px-4 py-2.5 text-[13px] font-semibold transition-all rounded-xl ${
            activeBtn === 'cancel'
              ? 'bg-slate-200 text-slate-800 ring-2 ring-slate-400 ring-offset-2'
              : 'bg-slate-100 text-slate-600 hover:bg-slate-200'
          }`}
        >
          Cancel
        </button>
        <button
          onClick={handleConfirm}
          disabled={localProducts.length === 0 || selectedUids.size === 0}
          className={`relative z-50 flex items-center justify-center gap-1.5 px-5 py-2.5 text-[13px] font-bold text-white rounded-xl cursor-pointer transition-all hover:scale-[1.02] active:scale-[0.98] disabled:opacity-50 disabled:cursor-not-allowed ${
            activeBtn === 'confirm' ? 'ring-2 ring-orange-500 ring-offset-2' : ''
          }`}
          style={{
            background: 'linear-gradient(135deg, #ea580c, #c2410c)',
            boxShadow: '0 4px 14px rgba(234, 88, 12, 0.4)',
          }}
        >
          <CheckCircle2 size={16} strokeWidth={2.5} />
          <span>Confirm & Add to Quotation</span>
        </button>
      </div>
    </Dialog>
  );
}